/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tickets_ReplyingInputs */

const en_settings_tickets_replying = /** @type {(inputs: Settings_Tickets_ReplyingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending...`)
};

const zh_settings_tickets_replying = /** @type {(inputs: Settings_Tickets_ReplyingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发送中…`)
};

/**
* | output |
* | --- |
* | "Sending..." |
*
* @param {Settings_Tickets_ReplyingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_tickets_replying = /** @type {((inputs?: Settings_Tickets_ReplyingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tickets_ReplyingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_tickets_replying(inputs)
	return zh_settings_tickets_replying(inputs)
});
export { settings_tickets_replying as "settings.tickets.replying" }